import { render, staticRenderFns } from "./auction-won-notice.vue?vue&type=template&id=37e5ef82&scoped=true&"
import script from "./auction-won-notice.vue?vue&type=script&lang=js&"
export * from "./auction-won-notice.vue?vue&type=script&lang=js&"
import style0 from "./auction-won-notice.vue?vue&type=style&index=0&id=37e5ef82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5ef82",
  null
  
)

export default component.exports